import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { KnBrDirectiveModule } from 'src/shared/directive/kn-br-directive.module';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, RoutingConfig } from '@spartacus/core';
import { CmsPageGuard, FormErrorsModule, PageLayoutComponent, SpinnerComponent } from '@spartacus/storefront';

import { AtgUserManagementComponent } from './atg-user-management.component';
import { AtgAddUserComponent } from './atg-add-user/atg-add-user.component';
import { AtgEditUserComponent } from './atg-edit-user/atg-edit-user.component';
import { AtgAddEditUsersListComponent } from './atg-add-edit-users-list/atg-add-edit-users-list.component';

@NgModule({
  declarations: [
    AtgUserManagementComponent,
    AtgAddUserComponent,
    AtgEditUserComponent,
    AtgAddEditUsersListComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbTooltipModule,
    KnBrDirectiveModule,
    SpinnerComponent,
    FormErrorsModule,
    RouterModule.forChild([
      {
        data: { pageLabel: '/user-management', cxRoute: 'atgAddUser' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard],
        component: PageLayoutComponent,
      },
    ]),
    // CMS component mappings
    ConfigModule.withConfig({
      cmsComponents: {
        // Renders atg-add-user or atg-edit-user based on service mode
        UserMangementComponent: {
          component: () => import('./atg-user-management.component').then((c) => c.AtgUserManagementComponent),
        },
      },
    } as CmsConfig),
    // Route definitions
    ConfigModule.withConfig({
      routing: {
        routes: {
          atgAddUser: { paths: ['user-management'], protected: true },
        },
      },
    } as RoutingConfig),
  ],
  exports: [
    AtgUserManagementComponent,
    AtgAddUserComponent,
    AtgEditUserComponent,
    AtgAddEditUsersListComponent,
  ],
})
export class AtgUserManagementModule {}
